import jwtDecode from 'jwt-decode';

export const getTokenExp = () => {
    return jwtDecode(sessionStorage.getItem('agronetToken')).exp;
};
export const getCompanyId = () => {
    return jwtDecode(sessionStorage.getItem('agronetToken')).companyId;
};

export const isSuperAdmin = () => {
    return jwtDecode(sessionStorage.getItem('agronetToken')).role === 'SUPER_ADMIN';
};

export const isDistributorAdmin = () => {
    return jwtDecode(sessionStorage.getItem('agronetToken')).role === 'DISTRIBUTOR_ADMIN';
};

export const isCompanyAdmin = () => {
    return jwtDecode(sessionStorage.getItem('agronetToken')).role === 'COMPANY_ADMIN';
};

export const isCustomer = () => {
    return jwtDecode(sessionStorage.getItem('agronetToken')).role === 'CUSTOMER';
};

export const isCompanyUser = () => {
    return jwtDecode(sessionStorage.getItem('agronetToken')).role === 'COMPANY_USER';
};

export const isDemoUser = () => {
    return jwtDecode(sessionStorage.getItem('agronetToken')).role === 'DEMO_USER';
};

export const getLoggedUserId = () => {
    return jwtDecode(sessionStorage.getItem('agronetToken')).userId;
};

export const randomDarkColor = () => {
    const lum = -0.25;
    let hex = String('#' + Math.random().toString(16).slice(2, 8).toUpperCase()).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    let rgb = "#",
        c, i;
    for (i = 0; i < 3; i++) {
        c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
        rgb += ("00" + c).substr(c.length);
    }
    return rgb;
};

export const getStatusColor = status => {
    switch (status) {
        case 'G':
            return '#22BF00'
        case 'O':
            return '#FFAC0C'
        case 'R':
            return '#F43B00'
        default:
            return '#646464'
    }
};

export const isValidNip = nip => {
    if (!nip) {
        return true;
    }
    nip = nip.replace(/[\ \-]/gi, '');

    let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
    let sum = 0;
    let controlNumber = parseInt(nip.substring(9, 10));
    let weightCount = weight.length;
    for (let i = 0; i < weightCount; i++) {
        sum += (parseInt(nip.substr(i, 1)) * weight[i]);
    }

    return sum % 11 === controlNumber;
}

export const isValidPhoneNumber = (number, canBeEmpty) => {
    if (!canBeEmpty && !number) {
        return false;
    } else if (!number) {
        return true;
    } else {
        const phoneNo = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/im;
        return phoneNo.test(number);
    }
};

export const formatDate = (dateValue) => {
    if(dateValue) {
        const date = new Date(dateValue);
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit"
        })
    } else {
        return '-'
    }
}

export const formatDateWithTime = (dateValue) => {
    if(dateValue) {
        const date = new Date(dateValue);
        return date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "2-digit",
            hour: "2-digit",
            minute: "2-digit"
        }).replace(",", "");
    } else {
        return '-'
    }
}
